module.exports = __webpack_public_path__ + "img/18a001-02.6865994d.png";